<template lang="pug">
  div
    template(v-for="description in description[locale]")
      p {{ description }}
    table.pf-offers-table
      thead
        tr
          th {{ $t('supplier') }}
          th {{ $t('insuranceName') }}
          th {{ $t('pricePerMonth') }}
          th {{ $t('pricePerYear') }}
          th
      tbody
        template(v-for="offer in offers")
          tr
            td
              a(href="javascript:;"
                :class="{ active: offer.companyId === selectedCompany }"
                @click="setActiveCompany(offer.companyId)"
                class="show-offer-detail-button")
                font-awesome-icon(icon="angle-down" class="mr-3")
              img.logo(:src="offer.insuranceCompany.logoUrl")
            td
              | {{ offer.productName }}
            td CHF {{ offer.pricePerMonth.toFixed(2) }}
            td CHF {{ offer.pricePerYear.toFixed(2) }}
            td
              button.pf-button.outline.inline.pf-btn-sm(@click="selectOffer(offer)")
                | {{ $t('select') }}
          tr(
            class="offer-details"
            v-if="offer.companyId === selectedCompany")
            td(colspan="5")
              table
                tr
                  td
                  td {{ $t('deductible') }}
                  td(colspan="2") CHF {{ offer.deductible.toFixed(2) }}
                tr
                  td
                  td {{ $t('cover') }}
                  td(colspan="2") CHF {{ offer.insuredSum.toFixed(2) }}
                tr
                  td
                  td {{ $t('hereditaryDiseases') }}
                  td(colspan="2") {{ yesNoConverter(offer.hereditaryDiseases) }}
    p *{{ $t('pricesCanBeChanged') }}
    BackButton
</template>

<script>
import {
  axiosGetData,
} from '@/support/utils';
import { mapState } from 'vuex';
import _ from 'lodash';
import ApiService from '../../services/api.service';
import BackButton from '../Common/BackButton.vue';

export default {
  name: 'Steptwo',
  data() {
    return {
      offers: [],
      selectedCompany: null,
      description: window.pet.description,
    };
  },
  components: {
    BackButton,
  },
  computed: {
    ...mapState({
      userInfos: (state) => state.userInfos,
    }),
    userCompany() {
      return this.userInfos.currentInsuranceCompany.groupId;
    },
    cheapestOffer() {
      return this.getCheapestOffer(this.insuranceInfos.insuranceModel);
    },
    companyOffer() {
      return this.getCurrentCompanyPrice(this.userInsuranceModel, this.userCompany);
    },
  },
  beforeMount() {
    this.$wait.start('Offers');
    const premiumData = [
      {
        key: 30,
        values: [
          this.userInfos.petType.toString(),
        ],
      },
      {
        key: 7,
        values: [
          this.userInfos.age.toString(),
        ],
      },
      {
        key: 31,
        values: [
          this.userInfos.deductible.toString(),
        ],
      },
      {
        key: 27,
        values: [
          this.userInfos.insuredSum.toString(),
        ],
      },
      {
        key: 32,
        values: [
          this.userInfos.hereditaryDiseases.toString(),
        ],
      },
    ];
    ApiService.post('BasicPetPremium/GetPremiums', premiumData)
      .then(axiosGetData)
      .then((response) => {
        this.offers = _.sortBy(response, ['premium']);
        this.$wait.end('Offers');
      });
  },
  methods: {
    selectOffer(offer) {
      this.$store.dispatch('setInsuranceInfos', offer);
      this.goToSpecificStep(3);
    },
    setActiveCompany(companyId) {
      if (this.selectedCompany === companyId) {
        this.selectedCompany = null;
      } else {
        this.selectedCompany = companyId;
      }
    },
  },
};
</script>
